import AHttpService from '@d-services/a-http-service/a-http-service';
import URLS from '@d-shared/urls/urls';

class MentionsService extends AHttpService {
  async search(term, page = 1) {
    const url = `${ URLS.api.mentions.replace('<term>', term) }&page=${ page }`;

    const response = await this._http.get(url);
    return response.data;
  }
}

export default new MentionsService();
